import './index.scss'

const Logo = () => {
    return (
        <div className="logo-container">
            <svg
                viewBox="0 0 559 897"
                xmlns="<http://www.w3.org/2000/svg>"
            >
                <path
                    className='path'
                    fill='none'
                    stroke='#247ba0'
                    strokeWidth={4}
                    d="M40 10.95v800m370-800h-80m140 40v800M180 270.474l210 580.475m-290 .001h80m210 0h80m-79.746-800h80M180 850.95V270.475M390 630V50.95m0 0-60-40m80 0 60 40m-430 760 60 40m290.258-.002-60.254-39.616m-.004-.382L180 397.307M100 50.95v800m80-800L390 630M330 10.95v449.948M100 50.95h80m-60-40 60 40m-140-40 60 40m-60-40h80"
                    
                />
            </svg>
        </div>
    )
}

export default Logo
